import React, { useState, useEffect, useRef } from 'react'
import { Box, Flex, P, ResponsiveSVG } from '../../../ui/acro'
import { SectionDivider } from '../../Home/SignedIn/common/styles'
import { SeeMoreButton } from '../common/MyPracticeStyles'
import SortableList from 'components_v1/sortableList/SortableList'
import { axios } from './../../../api'
import styled from 'styled-components'
import PlaylistCard from './Components/PlaylistCard'
import PlaylistCardMobile from './Components/PlaylistCardMobile'
import plusSVG from '../../../../../app/assets/images/add.svg'
import LikePlaylist from '../../../../../app/assets/images/LikePlaylist.jpg'
import MyPracticeDrawer from '../MyPracticeDrawer'
import CreatePlayList from '../CreatePlayList'
import { useUserContext } from 'context'
import { LIKED_ITEMS_SLUG } from 'components_v1/common'

const PlaylistCardContainer = styled(Flex)`
  width: 100%;
  gap: 2%;
  flex-wrap: wrap;
`
const CreatePlaylistRow = styled(Flex)`
  flex-direction: row-reverse;
  ${(props) => props.theme.mediaQueries.medium} {
    .SortableList {
      display: none;
    }
    flex-direction: row;
  }
`
const PlaylistCountRow = styled(Flex)`
  justify-content: space-between;
  width: 100%;
  margin-top: 24px;
  .SortableList {
    display: none;
  }
  ${(props) => props.theme.mediaQueries.medium} {
    .SortableList {
      display: block;
    }
    margin-top: 0px;
  }
`

const CreatePlaylistButton = styled(Flex)`
  font-family: ${(props) => props.theme.fonts.Proxima};
  font-size: 14px;
  font-weight: 500;
  // line-height: 24px;
  letter-spacing: 0.8px;
  text-transform: uppercase;
  border-radius: 360px;
  border: 1px solid #a3a3a3;
  gap: 12px;
  padding: 4px 24px;
  align-items: center;
  cursor: pointer;
  ${(props) => props.theme.mediaQueries.medium} {
    padding: 8px 24px;
    font-size: 16px;
  }
`

const MyPlaylists = ({ currentTab }) => {
  const [order, setOrder] = useState('date')
  const [userPlaylists, setUserPlayLists] = useState([])
  const [numberOfPlaylists, setNumberOfPlaylists] = useState()
  const [pageNumber, setPageNumber] = useState(1)
  const [isCompleted, setIsCompleted] = useState(true)
  const [isCreatePlaylist, setIsCreatePlayList] = useState(false)
  const sortOptionRef = useRef('date')
  const [drawerData, setDrawerData] = useState({ open: false })

  const { user } = useUserContext()
  const sortOptions = ['date', 'oldest']

  useEffect(() => {
    sortOptionRef.current = order
  }, [order])

  useEffect(() => {
    if (currentTab === 'playlists') {
      reloadPage()
    }
  }, [order, currentTab])

  useEffect(() => {
    const handlePageShow = (e) => {
      if (e.persisted) {
        // Page restored from bfcache
        const options = {
          pageNumber: 1
        }
        fetchData(options, true)
        setPageNumber(1)
      }
    }

    window.addEventListener('pageshow', handlePageShow)

    return () => {
      window.removeEventListener('pageshow', handlePageShow)
    }
  }, [])

  const fetchData = async (options, reloadRequired) => {
    let resetData = false
    if (reloadRequired) {
      resetData = true
      setPageNumber(1)
    }
    let params = {
      field: 'date',
      direction: sortOptionRef.current === 'oldest' ? 'asc' : 'desc', // newest by default
      per_page: 12,
      page: options?.pageNumber ? options?.pageNumber : pageNumber
    }
    try {
      const res = await axios.get(`playlists/me`, { params })
      if (res.status === 200) {
        if (resetData) {
          setUserPlayLists(res.data)
        } else {
          let updatedListOfPlaylists = userPlaylists.concat(res.data)
          setUserPlayLists(updatedListOfPlaylists)
        }
        setNumberOfPlaylists(res?.headers?.total)
      }
    } catch (e) {
      console.error(e)
    }
  }

  const onSortDropDownChange = (sortOption) => {
    if (order !== sortOption) {
      setOrder(sortOption)
      setPageNumber(1)
    }
  }

  useEffect(() => {
    if (userPlaylists && userPlaylists.length > 0) {
      if (userPlaylists.length >= Number(numberOfPlaylists)) {
        setIsCompleted(true)
      } else {
        setIsCompleted(false)
      }
    }
  }, [userPlaylists, numberOfPlaylists])

  const loadMore = () => {
    const options = {
      pageNumber: pageNumber + 1
    }
    fetchData(options)
    setPageNumber((prevPageNumber) => prevPageNumber + 1)
  }

  const reloadPage = () => {
    const options = {
      pageNumber: 1
    }
    fetchData(options, true)
    setPageNumber(1)
  }

  return (
    <Flex
      alignItems='center'
      flexDirection='column'
      justifyContent='flex-start'
      mt={['24px']}
      width={['100%']}
      pl={['30px']}
      pr={['30px']}
    >
      <CreatePlaylistRow
        flexDirection='row'
        justifyContent={['space-between']}
        pt={[0, 0]}
        pl={['0px']}
        pr={['0px']}
        width='100%'
        className='CreatePlaylistButtonRow'
      >
        <CreatePlaylistButton
          onClick={() => {
            setIsCreatePlayList(true)
          }}
        >
          <ResponsiveSVG SVG={plusSVG} width='20px' height='20px' />
          new Playlist
        </CreatePlaylistButton>
        <SortableList
          sortableFields={sortOptions}
          order={order}
          onSort={onSortDropDownChange}
        />
      </CreatePlaylistRow>
      <PlaylistCountRow
        style={{
          display: userPlaylists.length > 0 ? null : 'none'
        }}
      >
        <P alignSelf='flex-end' fontSize='16px'>
          {numberOfPlaylists} Playlists
        </P>
        <SortableList
          sortableFields={sortOptions}
          order={order}
          onSort={onSortDropDownChange}
        />
      </PlaylistCountRow>

      {userPlaylists.length > 0 && (
        <PlaylistCardContainer>
          {userPlaylists.map((playlist) => {
            return (
              <Box
                key={playlist.id}
                width={['100%', '48%', '23.5%', '23.5%']}
                pt={['32px']}
                borderBottom={['0']}
                style={{
                  position: 'relative',
                  cursor: 'pointer'
                }}
                className={'PlaylistCardContainer-List'}
              >
                {window.innerWidth > 640 ? (
                  <PlaylistCard
                    {...playlist}
                    coverPhoto={
                      playlist.uuid === LIKED_ITEMS_SLUG
                        ? LikePlaylist
                        : playlist.coverPhoto.url
                    }
                    alignBox={'left'}
                    pb='20px'
                    onClickHandler={() =>
                      setDrawerData({
                        ...playlist,
                        open: true
                      })
                    }
                  />
                ) : (
                  <PlaylistCardMobile
                    {...playlist}
                    coverPhoto={
                      playlist.uuid === LIKED_ITEMS_SLUG
                        ? LikePlaylist
                        : playlist.coverPhoto.url
                    }
                    alignBox={'left'}
                    pb='20px'
                    onClickHandler={() =>
                      setDrawerData({
                        ...playlist,
                        open: true
                      })
                    }
                  />
                )}
              </Box>
            )
          })}
          <MyPracticeDrawer
            isOpen={drawerData.open}
            onClose={() =>
              setDrawerData((state) => ({ ...state, open: false }))
            }
            id={drawerData.id}
            uuid={drawerData.uuid}
            title={drawerData.title}
            desc={drawerData.description}
            onSuccess={reloadPage}
            isOwner={drawerData?.author?.username === user?.username}
          />

          <SectionDivider />
        </PlaylistCardContainer>
      )}
      {
        <CreatePlayList
          isOpen={isCreatePlaylist}
          onClose={() => setIsCreatePlayList(false)}
          onSuccess={reloadPage}
        />
      }
      {!isCompleted && (
        <SeeMoreButton onClick={loadMore}>See More</SeeMoreButton>
      )}
    </Flex>
  )
}

export default MyPlaylists
